export const MATERIAL_TYPE = 'PART';
